var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoWrapper"},[_c('a',{attrs:{"href":_vm.logoLinkUrl,"data-testid":"logoAnchor"}},[_c('img',{class:_vm.logoClass,attrs:{"src":_vm.logoSource,"alt":_vm.altText,"data-testid":"logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }